import styles from "./home.module.css";

// import Swiper
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper as ReactSwiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const Swiper = () => {
  return (
    <div
      className={`sections-padding`}
      data-aos="fade-up"
      data-aos-anchor-placement="center-bottom">
      <div className={`${styles.six_content} container `}>
        <ReactSwiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          spaceBetween={30}
          breakpoints={{
            600: {
              slidesPerView: 1,
            },
            800: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}>
        </ReactSwiper>
      </div>
    </div>
  );
};

export default Swiper;
